import React from 'react';
import { FadeIn } from './FadeIn';
import { ThermometerSun, AlertTriangle } from 'lucide-react';
export function Problem() {
  return <section className="py-24 md:py-32 bg-gradient-to-b from-[#0B1029] to-[#111836] relative border-t border-white/5" data-id="element-190">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-center mb-16 text-[#F5D0A9]" data-id="element-193">
            The "Internal Thermostat" Glitch
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-194">
          <FadeIn delay={0.1} data-id="element-195">
            <div className="bg-white/[0.03] p-8 md:p-10 rounded-3xl border border-white/10 h-full hover:bg-white/[0.05] transition-colors" data-id="element-196">
              <div className="w-14 h-14 rounded-2xl bg-[#F2A68D]/10 flex items-center justify-center mb-8" data-id="element-197">
                <ThermometerSun className="w-7 h-7 text-[#F2A68D]" data-id="element-198" />
              </div>
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-light" data-id="element-199">
                If you are over 40, your "internal thermostat" is glitching.
                When estrogen or testosterone levels fluctuate, your brain's
                hypothalamus panics. It thinks you are overheating, so it
                triggers a "flush" to cool you down.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-200">
            <div className="bg-white/[0.03] p-8 md:p-10 rounded-3xl border border-white/10 h-full relative overflow-hidden hover:bg-white/[0.05] transition-colors" data-id="element-201">
              <div className="absolute top-0 right-0 w-40 h-40 bg-red-500/5 blur-3xl rounded-full" data-id="element-202" />
              <div className="w-14 h-14 rounded-2xl bg-red-400/10 flex items-center justify-center mb-8 relative z-10" data-id="element-203">
                <AlertTriangle className="w-7 h-7 text-red-400" data-id="element-204" />
              </div>
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-light relative z-10" data-id="element-205">
                To fuel that flush, your body dumps a massive hit of
                cortisol—your stress hormone—into your bloodstream. That is why
                you wake up wide awake, anxious, and over-heated in the middle
                of the night.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-206">
          <p className="text-2xl md:text-3xl font-serif text-white italic leading-relaxed" data-id="element-207">
            You aren't waking up because you're stressed; you're stressed
            because your hormones pulled the fire alarm while you were dreaming.
          </p>
        </FadeIn>
      </div>
    </section>;
}